import React from 'react'
import { Link } from 'react-router-dom'

const Error404 = () => {
     return (
          <div className='d-flex justify-content-center align-items-center' style={{minHeight:"90vh", width:"100%", background:"#143d53", color:"white"}}>
               <div>
                    <h1>404 Error</h1>
                    <h1>Page Not Found</h1>
                    <Link to="/">Go Back</Link>
               </div>

          </div>
     )
}

export default Error404